import { TFunction } from 'i18next';

type ApiErrorResponseLike = {
  status?: number;
  data?: unknown;
};

type ApiErrorLike = {
  response?: ApiErrorResponseLike;
};

type StructuredErrorBody = {
  type?: unknown;
  message?: unknown;
};

export type HermanUserEmailErrorType =
  | 'InvalidEmail'
  | 'DuplicateHermanUserEmail'
  | 'SessionManagerClientCompanyMismatch';

const isStructuredErrorBody = (data: unknown): data is StructuredErrorBody =>
  typeof data === 'object' && data !== null;

export const getHermanUserEmailErrorTypeFromResponse = (
  response?: ApiErrorResponseLike,
): HermanUserEmailErrorType | undefined => {
  if (!isStructuredErrorBody(response?.data)) return undefined;

  switch (response.data.type) {
    case 'InvalidEmail':
      return 'InvalidEmail';
    case 'DuplicateHermanUserEmail':
      return 'DuplicateHermanUserEmail';
    case 'SessionManagerClientCompanyMismatch':
      return 'SessionManagerClientCompanyMismatch';
    default:
      return undefined;
  }
};

export const getHermanUserEmailErrorType = (
  error: unknown,
): HermanUserEmailErrorType | undefined =>
  getHermanUserEmailErrorTypeFromResponse(
    (error as ApiErrorLike | null)?.response,
  );

export const describeHermanUserEmailErrorType = (
  type: HermanUserEmailErrorType,
  t: TFunction,
): string => {
  switch (type) {
    case 'InvalidEmail':
      return t('errors.invalidHermanUserEmail');
    case 'DuplicateHermanUserEmail':
      return t('errors.duplicateHermanUserEmail');
    case 'SessionManagerClientCompanyMismatch':
      return t('errors.sessionManagerClientCompanyMismatch');
  }
};

export const describeHermanUserEmailErrorResponse = (
  response: ApiErrorResponseLike | undefined,
  t: TFunction,
): string | undefined => {
  const type = getHermanUserEmailErrorTypeFromResponse(response);
  return type ? describeHermanUserEmailErrorType(type, t) : undefined;
};

export const describeHermanUserEmailError = (
  error: unknown,
  t: TFunction,
): string | undefined => {
  const type = getHermanUserEmailErrorType(error);
  return type ? describeHermanUserEmailErrorType(type, t) : undefined;
};
